import React from 'react';

import NormalButton from './NormalButton';

const AccentButton = prop => (
  <NormalButton
    {...prop}
    textColorClassName="theme--color-accent"
    iconFillClassName="theme--fill-accent"
  />
);

AccentButton.propTypes = NormalButton.propTypes;

module.exports = AccentButton;
